import { useDispatch } from "react-redux"
import { optimisticEntityUpdate } from "../../actions/entities"
import { camelizeKeys } from "humps"

export const useUpdateEntity = () => {
  const dispatch = useDispatch()
  return (entity: string, id: number, body: object) =>
    dispatch(optimisticEntityUpdate(entity, id, camelizeKeys(body)))
}
